import React from 'react';

const Course = (props) => (
    <div onClick={() => props.click(props.link)} className="udemy-course">
        <img src={props.logo} alt="Udemy Logo" />
        <div className="course__details">
            <div className="course__details__title">
                {props.title}
            </div>
            <div className="course__details__author">
                {props.author}
            </div>
            <div className="course__details__description">
                {props.description}
            </div>
        </div>
        <div className="course__status">
            <div className="course__status__progress">
                <div className="course__status__progress__bar" role="progressbar" aria-valuenow={props.completed} aria-valuemin="0" aria-valuemax="100" style={{ width: props.completed + "%" }}>
                </div>
            </div>
            <div className="course__status__percentage">{props.completed}% Complete</div>
        </div>
    </div>
);

export default Course;


// WEBPACK FOOTER //
// ./src/components/skills/Courses/course.js